import React from 'react';
import { Field } from 'redux-form';
import { NumberInput, TextInput } from 'react-admin';
import { createStyles, withStyles } from '@material-ui/core/styles';

import CodeMirrorInput from '../../../Common/Utils/CodeMirrorInput';

const styles = createStyles({
  fields: {
    width: '70%'
  }
});

type Props = {
  classes: any,
  record: any
};

const SourceMongo = (props: Props) => (
  <div>
    <div>
      <Field
        component={NumberInput}
        label="Min"
        name="min"
        source="min" />
      <span style={{ paddingLeft: 20 }}>
        <Field
          component={NumberInput}
          label="Max"
          name="max"
          source="max" />
      </span>
    </div>

    <div>
      <Field
        component={TextInput}
        label="Collection Name"
        name="table_name"
        source="table_name" />
    </div><br />

    <div>
      <Field name="query" component={CodeMirrorInput} label="Query * - (ruby hash syntax)" mode="ruby" />
    </div><br />
    Macros: CURRENT_DATE:offset i.e. CURRENT_DATE:-3, CURRENT_DATE:+2<br />
  </div>
);

export default withStyles(styles)(SourceMongo);



// WEBPACK FOOTER //
// ./src/views/Components/Monitors/Partials/SourceMongo.tsx